/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	var windowW = $(window).width();
	var windowH = $(window).innerHeight(); // テスト
	
	var _isTest = false;
	
	var _isSP;
	
	var windowW = window.innerWidth;
	var prewidth = window.innerWidth;
	
	var __layer = $('.st-Container').attr('data-layer'); //preload
	
	
	(0, _module.preload)(); //pageTop
	
	(0, _module.pageTop)(); //anchorLink
	
	(0, _module.anchorLink)(); //toggleHeader
	
	(0, _module.toggleHeader)();
	$(window).on('resize load', function () {
	  if (windowW <= 1024) {
	    _isSP = true;
	  } else {
	    _isSP = false;
	  }
	
	  ; //リサイズ処理 ブレイクポイントを跨いだらリロード
	
	  var nowWidth = window.innerWidth;
	
	  if (prewidth !== nowWidth) {
	    if (prewidth < 1025) {
	      if (nowWidth >= 1025) {
	        location.reload();
	      }
	    } else {
	      if (nowWidth < 1025) {
	        location.reload();
	      }
	    }
	  }
	
	  ;
	});
	$(window).on('load', function () {
	  scrollCommonAnime();
	
	  if (__layer == 'first') {
	    showAbout();
	  } else {
	    charaSlide();
	    playVoice();
	  }
	}); // ------------------------------------------------------------------------
	// showAbout
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var showAbout = function showAbout() {
	  $('.artist_Production').on('click', function () {
	    $('#about-Stage').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + '%',
	      'top': 0,
	      'left': 0
	    }, 300, 'easeOutQuart', function () {
	      // fadeIn
	      $('#about-Stage').stop().fadeIn(400);
	      $('#about-Box').addClass('show');
	      $('#about-Box_Txt').addClass('show');
	      return false;
	    });
	  }); //close
	
	  $('#about-Box_Close').on('click', function () {
	    $('#about-Stage').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 300, 'easeOutQuart', function () {
	      $('#about-Stage').css({
	        'display': 'none'
	      });
	      $('#about-Box').removeClass('show');
	      $('#about-Box_Txt').removeClass('show');
	    });
	  });
	}; // ------------------------------------------------------------------------
	// charaSlide
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var charaSlide = function charaSlide() {
	  var artistImg = new Swiper('.artist_Img_Container', {
	    loop: true,
	    // allowTouchMove: false,//スワイプを可能にするかどうか。デフォルトではtrue。
	    loopAdditionalSlides: 1,
	    //一瞬の途切れがなくなり、2周目以降も途切れることなくループできる
	    slidesPerView: 1,
	    effect: 'fade',
	    speed: 500,
	    fadeEffect: {
	      crossFade: true
	    },
	    navigation: {
	      nextEl: '.artist_Img_Button-Next',
	      prevEl: '.artist_Img_Button-Prev',
	      hideOnClick: true
	    },
	    preloadImages: false,
	    lazy: {
	      loadPrevNext: true,
	      //前後の画像を読み込む
	      loadPrevNextAmount: 1,
	      loadOnTransitionStart: true //スライドアニメーション前にロード
	
	    }
	  });
	}; // ------------------------------------------------------------------------
	// playVoice
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var playVoice = function playVoice() {
	  var _isSound = false;
	  $('.artist_Voice_Btn').on('click', function () {
	    var _this = this;
	
	    var dataVoice = $(this).attr('data-voice');
	    var sound = document.getElementById(dataVoice);
	    console.log(sound);
	
	    if (!_isSound) {
	      $(this).addClass('play');
	      sound.currentTime = 0;
	      sound.play();
	      _isSound = true;
	      sound.addEventListener("ended", function () {
	        $(_this).removeClass('play');
	        _isSound = false;
	      });
	    } else {
	      sound.pause();
	      $(this).removeClass('play');
	      _isSound = false;
	    }
	
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// scrollCommonAnime
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var scrollCommonAnime = function scrollCommonAnime() {
	  var controller = new ScrollMagic.Controller();
	  var targets = document.querySelectorAll(".sw-Ttl");
	  var targetsArray = Array.prototype.slice.call(targets); //Array
	
	  targetsArray.forEach(function (target) {
	    //シーンを作成
	    var scene = new ScrollMagic.Scene({
	      triggerElement: target,
	      triggerHook: 1
	    }).on("enter", function (event) {
	      // シーンの状態が"DURING"に入る際に発火する
	      // console.log("Scene entered.");
	      $(target).addClass("is-animated");
	      setTimeout(function () {
	        $(target).children(".en").textyle({
	          duration: 500,
	          //エフェクト時間(ミリ秒)
	          delay: 40,
	          //文字間のエフェクト間隔(ミリ秒)
	          // easing : 'swing', //エフェクトのイージングパターン
	          callback: function callback() {
	            $(target).addClass("is-completed");
	          }
	        });
	      }, 300);
	    }) // .setClassToggle(target, "is-animated")
	    .addTo(controller);
	  }); //　スクロールで発火系 その他
	
	  var targetsItem = document.querySelectorAll(".js-scrollAnimation");
	  var targetsItemArray = Array.prototype.slice.call(targetsItem); //Array
	
	  targetsItemArray.forEach(function (targetsItem) {
	    //シーンを作成
	    new ScrollMagic.Scene({
	      triggerElement: targetsItem,
	      triggerHook: 1
	    }).setClassToggle(targetsItem, "is-animated").addTo(controller);
	  });
	};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.anchorLink = exports.showMovie = exports.pageTop = exports.toggleHeader = exports.preload = void 0;
	var headerFlag = false;
	var stHeader = document.getElementById('st-Header');
	var stHeaderNav = document.getElementById('st-Header_Nav');
	var stHeaderBg = document.getElementById('st-Header_Bg');
	var headerButton = document.getElementById('st-Menu');
	var _isSP = false; // checkSP
	
	var checkSP = function checkSP() {
	  $(window).on('resize load', function () {
	    windowW = $(window).width();
	
	    if (windowW <= 1024) {
	      _isSP = true;
	    } else {
	      _isSP = false;
	    }
	
	    ;
	  });
	}; // ------------------------------------------------------------------------
	// preload
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	var preload = function preload() {
	  history.replaceState(null, null, null);
	  window.addEventListener('popstate', function () {
	    $('body').addClass('preload');
	    headerFlag = false;
	    stHeaderNav.classList.remove('opened');
	    headerButton.classList.remove('opened');
	    stHeaderBg.classList.remove('opened');
	    stHeaderLogo.classList.remove('opened');
	    stHeaderNav.classList.add('closed');
	    headerButton.classList.add('closed');
	    stHeaderBg.classList.add('closed');
	    stHeaderLogo.classList.add('closed');
	    setTimeout(function () {
	      $('body').removeClass('preload');
	    }, 100);
	  }, false);
	  $(window).on('load', function () {
	    $("body").removeClass("preload");
	  });
	}; // ------------------------------------------------------------------------
	// toggleHeader
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.preload = preload;
	
	var toggleHeader = function toggleHeader() {
	  headerButton.addEventListener('click', function () {
	    if (!headerFlag) {
	      // $('#st-Header_Navi').css({'display':'block'});
	      setTimeout(function () {
	        stHeader.classList.remove('closed');
	        stHeaderNav.classList.remove('closed');
	        headerButton.classList.remove('closed');
	        stHeaderBg.classList.remove('closed');
	        stHeader.classList.add('opened');
	        stHeaderNav.classList.add('opened');
	        headerButton.classList.add('opened');
	        stHeaderBg.classList.add('opened');
	        headerFlag = true;
	      }, 0);
	    } else {
	      stHeader.classList.remove('opened');
	      stHeaderNav.classList.remove('opened');
	      headerButton.classList.remove('opened');
	      stHeaderBg.classList.remove('opened');
	      stHeader.classList.add('closed');
	      stHeaderNav.classList.add('closed');
	      headerButton.classList.add('closed');
	      stHeaderBg.classList.add('closed');
	      headerFlag = false; // setTimeout(function(){
	      //   // $('#st-Header_Navi').css({'display':'none'});
	      // },0);
	    }
	  }, false); //フッターメニュー
	
	  $(".slide_Btn").on("click", function () {
	    $(this).next().slideToggle(300);
	    $(this).toggleClass("open");
	  });
	}; // ------------------------------------------------------------------------
	// pageTop
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.toggleHeader = toggleHeader;
	
	var pageTop = function pageTop() {
	  $("#st-Top").on("click", function () {
	    var linkSpeed = 800;
	    $("html, body").animate({
	      scrollTop: 0
	    }, linkSpeed, "easeOutExpo");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// showMovie
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.pageTop = pageTop;
	
	var showMovie = function showMovie() {
	  var $modal = $('#sw-Youtube');
	  var $content = $('#sw-Youtube_Content'); // open
	
	  $('.js-Youtube').on('click', function () {
	    var dataID = $(this).attr('data-youtube');
	    $('#sw-Youtube').css({
	      'opacity': '0',
	      'display': 'block'
	    }).stop().animate({
	      'opacity': '1',
	      'width': 100 + '%',
	      'height': 100 + 'vh',
	      'top': 0,
	      'left': 0
	    }, 500, 'easeOutQuart', function () {
	      //iframe append
	      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/' + dataID + '?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>'); // fadeIn
	
	      $modal.stop().fadeIn(400);
	      return false;
	    });
	  }); //close
	
	  $('#sw-Youtube_Close,#sw-Youtube_Overlay').on('click', function () {
	    $('#sw-Youtube').css({
	      'opacity': '1'
	    }).stop().animate({
	      'opacity': '0'
	    }, 500, 'easeOutQuart', function () {
	      $('#sw-Youtube').css({
	        'display': 'none'
	      });
	      $content.children('iframe').remove();
	    });
	  });
	}; // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.showMovie = showMovie;
	
	var anchorLink = function anchorLink() {
	  //ページ外からのページ内リンク
	  var urlHash = location.hash;
	
	  if (urlHash) {
	    $('body,html').stop().scrollTop(0);
	    setTimeout(function () {
	      var target = $(urlHash);
	      var position = target.offset().top - 80;
	      $('body,html').stop().animate({
	        scrollTop: position
	      }, 500);
	    }, 200);
	  }
	
	  var linkSpeed = 1000;
	  var linkAdjust = 50; //ページ内リンク
	
	  $("a[href^='#']").on("click", function () {
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "easeInOutQuint");
	    return false;
	  });
	}; // // bgAnime
	// const bgAnime = () => {
	//   let bgBox = $(".st-Bg-shooting_star-l");
	//   var positionBg = 0; //初期値を取得
	//   //横幅のリサイズだけ検出
	//   var lastInnerWidth = window.innerWidth ;
	//   window.addEventListener( "resize", function () {
	//     // 現在と前回の横幅が違う場合だけ実行
	//     if ( lastInnerWidth != window.innerWidth ) {
	//       bgBox.css('top', '');
	//       positionBg = 0; //初期値を取得
	//       // 横幅を記録しておく
	//       lastInnerWidth = window.innerWidth;
	//     }
	//   }) ;
	//   $(window).on("scroll load", function(){
	//     var value = $(this).scrollTop();
	//     var h = $(window).height();
	//     if(_isSP){
	//         bgBox.css('backgroundPosition', -value / 200);
	//     } else {
	//         bgBox.css({
	//           backgroundPositionX: '-value / 200',
	//           backgroundPositionY: '-value / 80',
	//         });
	//     };
	//   });
	// };
	

	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// artist/app.bundle.js